import { getDefaultSPPageContext } from './getDefaultSPPageContext';
import { SharingDataSource } from '@ms/odsp-datasources/lib/dataSources/sharing/SharingDataSource';
import { SharingProvider } from '@ms/odsp-datasources/lib/providers/sharing/SharingProvider';
import { ClientId, Mode } from '@ms/odsp-shared-sharing/lib/interfaces/SharingInterfaces';
import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export async function getDefaultSharingProvider(webUrl: string, itemUrl: string) {
    const spPageContext = await getDefaultSPPageContext(webUrl);

    let token = await getFileProviderAuthHeaderValue(
        AttachmentDataProviderType.OneDrivePro,
        false,
        webUrl
    );
    token = token.substring(7); // Both the existing code and the SharePoint code add 'Bearer' before the token, so we strip it here.

    const sharingContextInformation = {
        authToken: token,
        webAbsoluteUrl: webUrl,
        userDisplayName: 'OneDrive user',
        isODB: true,
        itemName: '',
        isMacV4ExperimentOn: false,
        organizationName: 'Microsoft',
        clientId: ClientId[ClientId.outlookWeb],
        itemUrl: itemUrl,
        mode: Number(Mode.linkSettings),
        defaultRecipients: [],
    };

    const sharingDataSource = new SharingDataSource({
        pageContext: spPageContext,
        getParentListId: getParentListId,
        sharingContextInformation: sharingContextInformation,
        usesSharingAbilities: true,
    });

    return new SharingProvider({
        pageContext: spPageContext,
        getParentListId: getParentListId,
        itemProvider: null,
        sharingDataSource: sharingDataSource,
    });
}

function getParentListId(item: any) {
    return null;
}
